import type { InjectionKey, Ref } from 'vue'

export const SCROLL_CONTAINER_INJECTION_KEY = Symbol(
  'scroll-container-injection-key',
) as InjectionKey<Ref<HTMLElement | null>>
